import { render } from "./AutoSignIn.vue?vue&type=template&id=2b4c07dd"
import script from "./AutoSignIn.vue?vue&type=script&lang=js"
export * from "./AutoSignIn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__